import { useContext } from "react";
import { ConfigContext } from "providers/ConfigProvider";

export const useConfig = () => {
  return useContext(ConfigContext);
};
